import React from 'react';
import './tailwind.css'
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import HomePage from './pages/Home'
import FarmsPage from './pages/Farms'
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MillPage from './pages/Mill';
import ScrollToTop from './components/ScrollToTop';
import OfferingPage from './pages/Offerings';
import AboutPage from './pages/About';
import ContactPage from './pages/Contact';

function App() {
  return (
    <div className="">
      <Router>
        <ScrollToTop />
        <Navbar />
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/farms" component={FarmsPage} />
          <Route exact path="/mill" component={MillPage} />
          <Route exact path="/offerings" component={OfferingPage} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/contact" component={ContactPage} />
        </Switch>
        <Footer/>
      </Router>
    </div>
  );
}

export default App;
